
export default function subscriptionTypeReducer(state = "basic", {type, payload}) {

	switch(type) {
		case 'SET_SUBSCRIPTION_TYPE': return payload.subscriptionType;
		default: return state;
	}
}